import { createFileRoute } from '@tanstack/react-router';
import { AdminRegistryPage } from '../../features/catalogue';

export const Route = createFileRoute('/admin/catalogue/platform-charge-items')({
  component: AdminRegistryPage,
});
